<template>
    <div class="ts-finder">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
    import $ from 'jQuery'

    export default {
        created() {
            this.$store.dispatch('loadStrings');
            $(window.document.body).addClass('ts-finder-body');
        }
    };
</script>